import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Row, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setPageTitle } from "../../../app/features/DataSlice";
import HeliorPurchaseForm from "../../../components/HeliorPlan/HeliorPurchaseForm";
import HeliorPurchaseSummary from "../../../components/HeliorPlan/HeliorPurchaseSummary";
import { initialHPPurchaseData } from "../../../helpers";
import { selectProductData } from "../../../app/features/ProductSlice";
import { useTranslation } from "react-i18next";
import {
  useGetValueQuery,
  useIsKeyAvailableQuery,
  useGetLatestCurrencyRatesQuery,
} from "../../../app/features/apiSlice";
import Loader from "../../../components/Loader";

const HeliorPlan = () => {
  const { t } = useTranslation();
  const data = useSelector(selectProductData);
  const pageTitle = "XPlan";
  const sessionId = useRef(Date.now()).current;
  const dispatch = useDispatch();
  const [purchaseData, setPurchaseData] = useState({
    ...initialHPPurchaseData,
    ...data,
  });

  const [formData, setformData] = useState({
    type: "",
    recurringAmount: [],
    minRecurringPaymentNumber: 0,
    maxRecurringPaymentNumber: 0,
  });
  const [currency, setCurrency] = useState(data.currency || "CHF");
  const staticData = useGetValueQuery({ sessionId });
  const { data: ratesData } = useGetLatestCurrencyRatesQuery({ sessionId });
  const rate = currency === "CHF" ? 1 : (ratesData?.data?.[currency] ?? 1);

  const {
    data: eosKey,
    isLoading,
    refetch,
  } = useIsKeyAvailableQuery({ sessionId });

  const resetPurchaseData = () => {
    const staticValues = staticData.isSuccess
      ? {
          guaranteeMargin: staticData.data.guaranteeMargin,
          txBankFee: staticData.data.txBankFee,
          txCryptoFee: staticData.data.txCryptoFee,
          txFeeCC: staticData.data.txFeeCC,
          stampDuty: staticData.data.stampDuty,
        }
      : {};

    setPurchaseData({
      ...initialHPPurchaseData,
      ...staticValues,
    });
  };

  useEffect(() => {
    if (staticData.isSuccess) {
      const { guaranteeMargin, txCryptoFee, txFeeCC, stampDuty } = staticData.data;
      setPurchaseData((prev) => ({
        ...prev,
        guaranteeMargin,
        txCryptoFee,
        txFeeCC,
        stampDuty,
      }));
    }
  }, [staticData]);

  useEffect(() => {
    dispatch(setPageTitle(pageTitle));
    // eslint-disable-next-line
  }, []);

  if (isLoading) return <Loader />;

  return (
    <Row>
      <Col lg={7}  className="mb-3 mb-lg-0">
        <Card bg="dark1 text-light">
          <Card.Body>
            <HeliorPurchaseForm
              purchaseData={purchaseData}
              setPurchaseData={setPurchaseData}
              resetPurchaseData={resetPurchaseData}
              formData={formData}
              setformData={setformData}
              eosKey={eosKey}
              refetch={refetch}
              currency={currency}
              setCurrency={setCurrency}
              rate={rate}
              ratesData={ratesData}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col lg={5} className="position-relative">
        <Card bg="dark1 text-light mb-3">
          <Card.Body>
            <HeliorPurchaseSummary
              purchaseData={purchaseData}
              setPurchaseData={setPurchaseData}
              formData={formData}
              eosKey={eosKey}
              currency={currency}
              rate={rate}
            />
          </Card.Body>
        </Card>
        <Form.Text id="passwordHelpBlock" className="text-light">
          <br /> <b>{t("docDiscountNote1")}</b>
        </Form.Text>
      </Col>
    </Row>
  );
};

export default HeliorPlan;
